import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { injectIntl } from 'react-intl';

import { compose } from 'recompose';
import { IS_TENANT } from 'tenant/config';

const enhance = compose(injectIntl);

const WeightCell = React.memo(({ max_weight, total_weight, total_goods_weight, intl, showMax }) => {
  const units = intl.messages.units;
  const weight = showMax ? max_weight : total_weight;

  return (
    <Fragment>
      {IS_TENANT ? total_goods_weight : weight} {units.kg}
    </Fragment>
  );
});

WeightCell.propTypes = {
  max_weight: PropTypes.number,
  total_weight: PropTypes.number,
  intl: PropTypes.object.isRequired,
  showMax: PropTypes.bool,
};

WeightCell.defaultProps = {
  max_weight: null,
  total_weight: null,
  showMax: false,
};

export default enhance(WeightCell);
